$(function() {
            
            var jmpressOpts   = {
               animation      : { transitionDuration : '0.8s' }
            };
            
            $( '#jms-slideshow' ).jmslideshow( $.extend( true, { jmpressOpts : jmpressOpts }, {
               autoplay : true,
               bgColorSpeed: '0.8s',
               arrows      : true,
               dots:false
            }));
            
         });
$(document).ready(function(){

  $('.sldr-blg').bxSlider({
    mode: 'vertical',
    slideWidth: 220,
    minSlides: 3,
    slideMargin: 10,
    speed:2000,
    infiniteLoop:true,
    touchEnabled:true,
    pager:false,
    auto:true,
    moveSlides:3,
    autoHover:true
  });

    $('.sldr-hm-sale').bxSlider({
    slideWidth: 270,
    minSlides: 2,
    maxSlides: 3,
    slideMargin: 10,
    infiniteLoop:true,
    touchEnabled:true,
    pager:false,
    auto:true,
    autoHover:true
  });

    $('.sldr-prdct-thumb').bxSlider({
    slideWidth: 50,
    minSlides: 2,
    maxSlides: 5,
    slideMargin: 4,
    infiniteLoop:false,
    hideControlOnEnd:true,
    pager:false,
    auto:false,
    autoHover:true
  });
   $('.popup-slct').customSelect({customClass:'Prod-Pg-Select'});
   $('.mob-mnu').customSelect({customClass:'mobile-Mnu-Select'});
   $('.curncy').customSelect({customClass:'curr-Select'});


  $('.single-option-selector').sSelect();
  $('.e1').sSelect();

  $("#best-slr").perfectScrollbar({
  wheelSpeed: 50
 })


});
